
const reportJsError = (data) => {
	try {
		// Add the page debug data (web_hit_id, server)
		$.extend(data, $("#page-debug-info").data());

		// Add other info
		data.url = location.href;
		data.referrer = document.referrer;
		data.documentIsReady = (typeof window.documentIsReady != "undefined") ? window.documentIsReady : false;

		// Post to the js error page, let that handle the notifications
		$.post("/ajax/jserror", data);
	} catch (e) {

	}
}

// What IE version is this?
const getIEVersion = () => {
	const agent = navigator.userAgent;
	const reg = /MSIE\s?(\d+)(?:\.(\d+))?/i;
	const matches = agent.match(reg);
	if (matches != null) {
		return {major: matches[1], minor: matches[2]};
	}
	return {major: "-1", minor: "-1"};
}

window.onerror = (errorMsg, file, lineNumber, columnNumber, errorObj) => {
	// Ignore IE. MRF 8/4/2021
	const ieVersion = getIEVersion();
	if ((ieVersion.major > 0)) {
		return;
	}

	// Pass error-specific information to the reporting function
	reportJsError({
		error: errorMsg,
		file: file,
		lineNumber: lineNumber,
		columnNumber: columnNumber,
		stackTrace: ((errorObj != null) && (typeof errorObj != "undefined") && (typeof errorObj.stack != "undefined")) ? errorObj.stack : "",
		s_defined: (typeof s != "undefined"),
	});
};